export default "__VITE_ASSET__DEMTjhSG__"